import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Assets
import LogoImg from "../../assets/svg/Logo";

export default function Contact() {

  const getCurrentYear = () => {
    return new Date().getFullYear();
  }

  return (
    <Wrapper>
      <div className="darkBg">
        <div className="container">
          <InnerWrapper className="flexSpaceBetween" style={{ padding: "30px 0" }}>
            {/* Left Side: Name, Email, and Phone */}
            <LeftSide>
              <h1 className="font15 extraBold whiteColor">Eryvez Pvt Ltd</h1>
              <p className="font13 whiteColor">
                Email: <a href="mailto:info@eryvez.com" className="purpleColor">info@eryvez.com</a>
              </p>
              <p className="font13 whiteColor">
                Phone: <a href="tel:+94768839673" className="purpleColor">+94 768839673</a>
              </p>
            </LeftSide>

            {/* Right Side: Logo */}
            <RightSide>
              <Link className="flexCenter animate pointer" to="home" smooth={true} offset={-80}>
                <LogoImg />
              </Link>
            </RightSide>
          </InnerWrapper>

          {/* All Rights Reserved at the bottom */}
          <BottomWrapper>
            <StyleP className="whiteColor font13">
              © {getCurrentYear()} - <span className="purpleColor font13">Eryvez</span> All Rights Reserved
            </StyleP>
          </BottomWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;

const InnerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 550px) {
    flex-direction: column;
    align-items: center;
  }
`;

const LeftSide = styled.div`
  text-align: left;

  h1 {
    margin-bottom: 10px;
  }

  p {
    margin: 5px 0;
  }

  a {
    text-decoration: none;
    color: inherit;

    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: 550px) {
    text-align: center;
    margin-bottom: 20px;
  }
`;

const RightSide = styled.div`
  text-align: right;

  @media (max-width: 550px) {
    text-align: center;
    margin-bottom: 20px;
  }
`;

const BottomWrapper = styled.div`
  text-align: center;
  padding: 15px 0;

  @media (max-width: 550px) {
    padding: 10px 0;
  }
`;

const StyleP = styled.p`
  margin: 0;

  @media (max-width: 550px) {
    margin: 20px 0;
  }
`;
